module.exports = __webpack_public_path__ + "img/cake.f68206fe.svg";